<template>
  <div class="pcg-scrollbars">
    <div class="pcg-scrollbars__content" @scroll="onScroll" ref="scrollContent">
      <slot/>
    </div>
    <div class="pcg-scrollbars__bar" :style="scrollbarStyleY" @mousedown="startScrolling" v-if="showScrollbarY"></div>
  </div>
</template>

<script>
import {computed, reactive, ref} from "@vue/reactivity";
import {onBeforeUnmount, onMounted} from "@vue/runtime-core";

export default {
  name: "Scrollbars",
  setup() {
    const scrollContent = ref();

    const scrollProgressY = ref(0);
    const showScrollbarY = ref(true);

    // height is not dynamic (yet)
    const scrollbarHeight = ref(100);
    const scrollbarStyleY = reactive({
      top: "0",
      height: computed(() => `${scrollbarHeight.value}px`)
    });

    // logic
    const currentlyScrolling = ref(false);
    const scrollStartPos = ref(0);
    const scrollStartPosMouse = ref(0);
    const startScrolling = (event) => {
      event.preventDefault();
      scrollStartPos.value = scrollContent.value.scrollTop;
      scrollStartPosMouse.value = event.y;
      currentlyScrolling.value = true;
    }
    const stopScrolling = () => {
      currentlyScrolling.value = false;
    }

    const drag = (event) => {
      if (currentlyScrolling.value) {
        const relScrollBar = (event.y - scrollStartPosMouse.value) / (scrollContent.value.clientHeight - scrollbarHeight.value - 4);
        const relScrollTop = (scrollContent.value.scrollHeight - scrollContent.value.clientHeight) * relScrollBar;
        scrollContent.value.scrollTop = scrollStartPos.value + relScrollTop;
      }
    }

    const updateVisibility = () => {
      showScrollbarY.value = scrollContent.value?.scrollHeight > scrollContent.value?.clientHeight;
    }
    const resizeObserver = new ResizeObserver(updateVisibility);
    const mutationObserver = new MutationObserver(updateVisibility);
    onMounted(() => {
      document.addEventListener('mousemove', drag);
      document.addEventListener('mouseup', stopScrolling);
      resizeObserver.observe(scrollContent.value);
      mutationObserver.observe(scrollContent.value, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    });
    onBeforeUnmount(() => {
      document.removeEventListener('mousemove', drag);
      document.removeEventListener('mouseup', stopScrolling);
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    });

    const onScroll = ({target}) => {
      scrollProgressY.value = target.scrollTop / (target.scrollHeight - target.clientHeight);
      scrollbarStyleY.top = `${(target.clientHeight - scrollbarHeight.value - 4) * scrollProgressY.value}px`;
    }

    return {
      showScrollbarY,
      onScroll,
      scrollbarStyleY,
      scrollContent,
      scrollProgressY,
      currentlyScrolling,
      startScrolling,
      drag
    }
  }
}
</script>

<style scoped lang="scss">
.pcg-scrollbars {
  height: 100%;
  width: 100%;
  max-height: inherit;
  max-width: inherit;
  position: relative;

  &__content {
    height: 100%;
    width: 100%;
    max-height: inherit;
    max-width: inherit;
    overflow: auto;
    position: relative;

    /* hide original scrollbars */
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none
    }
  }

  &__bar {
    background-color: #7b7b7b;
    width: 7px;
    position: absolute;
    top: 0;
    right: 0;
    margin: 2px;
    border-radius: 100px;
  }
}
</style>